import {AddressProps, translatedAddressProps} from 'modules/addresses/types';
import {
  BillingRecorencyEnum,
  CityProps,
  translatedCityProps,
} from 'modules/cities/types';
import {SponsorTypeEnum} from 'modules/coupons/types';
import {
  NeighborhoodProps,
  translatedNeighborhoodProps,
} from 'modules/neighborhoods/types';
import {PaymentMethodProps} from 'modules/payment-methods/types';
import {SegmentProps} from 'modules/segments/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export enum DeliveryModeEnum {
  free = 'free',
  fixed = 'fixed',
  neighborhood = 'neighborhood',
}

export enum CompanyStatusEnum {
  awaiting_approval = 'awaiting_approval',
  inactive = 'inactive',
  active = 'active',
}

export enum AutoPrintEnum {
  order_accepted = 'order_accepted',
  skip_preparing = 'skip_preparing',
}

export interface ScheduleProps {
  start: string;
  end: string;
}

export interface WorkingPeriodProps {
  day: string;
  active: boolean;
  schedules: ScheduleProps[];
}

export interface CompanyProps {
  id: string;
  name: string;
  description?: string;
  email: string;
  cnpj: string;
  logo: string;
  banner: string;
  phone: string;
  addressId: string;
  address: AddressProps;
  cityId: string;
  city: CityProps;
  deliveryMode: DeliveryModeEnum;
  deliveryPrice?: number;
  deliveryByCompany: boolean;
  useCompanyDeliveryZones: boolean;
  freeDelivery?: boolean;
  segmentsIds: string[];
  segments: SegmentProps[];
  excludedPaymentMethodsIds: string[];
  excludedPaymentMethods: PaymentMethodProps[];
  workingPeriods: WorkingPeriodProps[];
  active: boolean;
  deliveryTime: number;
  billingRecorency?: BillingRecorencyEnum;
  status: CompanyStatusEnum;
  ratting: number;
  rattings: any[];
  available: boolean;
  freeDeliveryThreshold?: number;
  freeDeliverySponsor: SponsorTypeEnum;
  isOpened?: boolean;
  pixKey?: string;
  allowPickup: boolean;
  allowPickupPayment: boolean;
  autoPrint: AutoPrintEnum;
  minOrderValue?: number;
}

export interface CompanyNeighborHoodPriceProps {
  id: string;
  companyId: string;
  deliveryPrice: number;
  deliveryManFee?: number;
  neighborhoodId: string;
  neighborhood: NeighborhoodProps;
}

export const translatedCompanyProps: TranslatedKeys<CompanyProps> = {
  name: 'Nome',
  description: 'Descrição',
  email: 'Email',
  cnpj: 'Cnpj',
  logo: 'Logo',
  banner: 'Banner',
  phone: 'Telefone',
  addressId: 'Endereço',
  address: translatedAddressProps,
  cityId: 'Cidade',
  city: {...translatedCityProps, name: 'Cidade'},
  deliveryMode: 'Tipo da taxa de entrega',
  deliveryPrice: 'Taxa de entrega',
  deliveryByCompany: 'Entrega própria?',
  useCompanyDeliveryZones: 'Usar zona de entrega da empresa?',
  freeDelivery: 'Frete grátis?',
  segmentsIds: 'Segmentos',
  segments: 'Segmentos',
  excludedPaymentMethodsIds: 'Formas de pagamento excluídas',
  excludedPaymentMethods: 'Formas de pagamento excluídas',
  workingPeriods: 'Horários de funcionamento',
  active: 'Ativo?',
  deliveryTime: 'Tempo de entrega',
  billingRecorency: 'Recorrência do fechamento',
  status: 'Status',
  ratting: 'Avalição',
  rattings: 'Avaliações',
  available: 'Disponível?',
  freeDeliveryThreshold: 'Frete grátis a partir de',
  freeDeliverySponsor: 'Patrocinador frete grátis',
  pixKey: 'Chave pix',
  allowPickup: 'Permitir retirada?',
  allowPickupPayment: 'Permitir pagamento na retirada?',
  autoPrint: 'Impressão automática',
  minOrderValue: 'Valor mínimo do pedido',
};

export const translatedWorkingPeriodProps: TranslatedKeys<WorkingPeriodProps> =
  {day: 'Dia', active: 'Ativo?', schedules: 'Horários'};

export const translatedScheduleProps: TranslatedKeys<ScheduleProps> = {
  start: 'Horário de início',
  end: 'Horário de fim',
};

export const translatedCompanyNeighborHoodPriceProps: TranslatedKeys<CompanyNeighborHoodPriceProps> =
  {
    companyId: 'Empresa',
    neighborhoodId: 'Bairro',
    neighborhood: translatedNeighborhoodProps,
    deliveryPrice: 'Taxa de enterga',
    deliveryManFee: 'Taxa do entregador',
  };
